//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Confirm from '../../../../shared-components/vuetify/dialog/Confirm';

export default {
  name: 'UnidadeMedidaForm',
  data() {
    return {
      unidadeMedidaResources: this.$api.unidadeMedida(this.$resource),

      unidade: {},
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
      },
      dialog: {
        content: '',
      },
    };
  },
  watch: {
  },
  components: {
    Confirm,
  },
  methods: {
    cancel() {
      this.limparFormulario();
    },
    editar(unidade) {
      this.unidade = { ...unidade };
    },
    limparFormulario() {
      this.unidade = {};
      this.$refs.form.reset();
    },
    openSaveDialog() {
      if (!this.$refs.form.validate()) return;
      this.dialog.content = this.$t('message.salvar');
      this.$refs.confirmDialog.open();
    },
    save() {
      let salvarOuAtualizar;
      let inclusao = true;

      if (this.unidade.id != null) {
        inclusao = false;
        salvarOuAtualizar = this.unidadeMedidaResources.atualizar(this.unidade);
      } else {
        salvarOuAtualizar = this.unidadeMedidaResources.gravar(this.unidade);
      }

      salvarOuAtualizar
        .then(() => this.limparFormulario())
        .then(() =>
          this.$toast.create(
            this.$t(
              inclusao
                ? 'message.adicionado_confira_tabela'
                : 'message.atualizado_confira_tabela',
            ),
            'snack',
            3e3,
          ),
        )
        .then(() => {
          this.$emit('FORMULARIO_CADASTRO_UNIDADE_SALVAR', this.unidade, this.clearForm);
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  computed: {
    ehEdicao() {
      return this.unidade.id;
    },
  },
  mounted() {

  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/unidade-medida/UnidadeMedidaForm.vue?vue&type=script&lang=js&